/**
 * Gestione Mense Backend Authentication API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import { UserType } from './userType';

export interface UserFilterForm { 
    /**
     * cognome
     */
    cognome?: string;
    /**
     * nome
     */
    nome?: string;
    /**
     * codice pratica
     */
    codicePratica?: string;
    /**
     * numero cellulare
     */
    cellulare?: string;
    /**
     * email
     */
    email?: string;
    userType?: UserType;
    /**
     * stato attivazione account
     */
    accountActivated?: boolean;
    /**
     * stato email
     */
    accountEnabled?: boolean;
}